
import Datetime from 'vux/src/components/datetime/index.vue'
import Group from 'vux/src/components/group/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'

import { mapGetters } from 'vuex';
import api from '../../api';
import UpLoad from '../../components/LoansUpload';

export default {

beforeRouteEnter: (to, from, next) => {
next((vm) => {
});
},
components: {
Datetime,
Group,
XInput,
UpLoad,
XButton,
},
mounted() {
this.getInfo();
},
activated() {
},
watch: {
},
data() {
return {
formData: {
license: '',
regAmount: '',
regDate: '',
businessPaper: '',
transportPaper: '',
accountPaper: '',
insurancePaper: '',
},
};
},
computed: {
...mapGetters([
'isLower',
'isUpper',
]),
companyStatus() {
return this.$store.state.companyStatus;
},
},
methods: {
getBpUrl(data) {
this.formData.businessPaper = data.url;
},
getTpUrl(data) {
this.formData.transportPaper = data.url;
},
getApUrl(data) {
this.formData.accountPaper = data.url;
},
getIpUrl(data) {
this.formData.insurancePaper = data.url;
},
save() {
const { license, regAmount, regDate, businessPaper, transportPaper, accountPaper, insurancePaper } = this.formData;
if ((license === '' || regAmount === '' || regDate === '' || businessPaper === '' || transportPaper === '') && this.isLower) {
this.$vux.toast.text('请完善信息');
} else if ((license === '' || regAmount === '' || regDate === '' || businessPaper === '') && !this.isLower) {
this.$vux.toast.text('请完善信息');
} else {
api.vega.company.updateCompanyInfoPageThree(this.formData).then((res) => {
const code = res.data;
const _this = this;
if (code.code === 0 && code.sub_code === 0) {
if (this.companyStatus !== 0) {
this.$vux.confirm.show({
showCancelButton: false,
confirmText: '我知道了',
content: `<i class="iconfont icon-chenggong"></i>
<p class="save_ok">保存成功</p>`,
onConfirm () {
_this.$router.go(-1);
}
});
} else {
this.$router.push({
name: 'authComplete',
});
}
}
})
}
},
getInfo() {
api.vega.company.getCompanyInfoPageThree({}).then((res) => {
const data = res.data.data;
this.formData = data;
})
},
},
};
